import { render, staticRenderFns } from "./ComplaintSectorDelete.vue?vue&type=template&id=2a026a7c&"
import script from "./ComplaintSectorDelete.vue?vue&type=script&lang=js&"
export * from "./ComplaintSectorDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports